import Vue from 'vue'
import Vuex from 'vuex'
import tokenApi from '@/api/token.js'
import tokenJwt from '@/utils/token.js'
import { 
    getRouteTitleHandled,
    routeHasExist,
    setTagNavListInLocalstorage,
    getTagNavListFromLocalstorage,
    getHomeRoute,
    routeEqual,
    getNextRoute
} from '@/utils/index.js'
import api from '@/api/index.js'
import router from '@/router'

const homeName = '首页'
const closePage = (state, route) => {
    const nextRoute = getNextRoute(state.tagNavList, route)
    state.tagNavList = state.tagNavList.filter(item => {
      return !routeEqual(item, route)
    })
    router.push(nextRoute)
}
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        token: "",
        name: "",
        type:'',
        id: "",
        expried: "",
        refresh_token: "",
        permission: "",
        tagNavList: [],//存储的tag
        homeRoute: {},
        hospitalList:[]
    },
    getters: {
        token(state) {
            return state.token;
        },
        refresh_token(state) {
            return state.refresh_token;
        },
        name(state) {
            return state.name;
        },
        type(state) {
            return state.type;
        },
        id(state) {
            return state.id;
        },
        expried(state) {
            return state.expried;
        },
        permission(state) {
            return state.permission;
        }
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        setHospitalList(state,hospitalList) {
            state.hospitalList = hospitalList;
        },
        SET_REFRESH_TOKEN(state, refresh_token) {
            state.refresh_token = refresh_token;
        },
        SET_NAME(state, name) {
            state.name = name;
        },
        SET_ID(state, id) {
            state.id = id;
        },
        SET_TYPE(state, type) {
            state.type = type;
        },
        SET_EXPRIED(state, expried) {
            state.expried = expried;
        },
        SET_PERMISSION(state, permission) {
            state.permission = permission;
        },
        setHomeRoute (state, routes) {
            state.homeRoute = getHomeRoute(routes, '首页')
          },
        setTagNavList (state, list) {
            let tagList = []
            if (list) {
              tagList = [...list]
            } else tagList = getTagNavListFromLocalstorage() || []
            if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
            let homeTagIndex = tagList.findIndex(item => item.name === homeName)
            if (homeTagIndex > 0) {
              let homeTag = tagList.splice(homeTagIndex, 1)[0]
              tagList.unshift(homeTag)
            }
            state.tagNavList = tagList
            setTagNavListInLocalstorage([...tagList])
        },
        closeTag (state, route) {
            let tag = state.tagNavList.filter(item => routeEqual(item, route))
            route = tag[0] ? tag[0] : null
            if (!route) return
            closePage(state, route)
        },
        addTag(state,{ route, type = 'unshift' }){
            let router = getRouteTitleHandled(route)
            if (!routeHasExist(state.tagNavList, router)) {
                if (type === 'push') state.tagNavList.push(router)
                    else {
                if (router.name === homeName) state.tagNavList.unshift(router)
                    else state.tagNavList.splice(1, 0, router)
                }
                setTagNavListInLocalstorage([...state.tagNavList])
            }
        }
    },
    actions: {
        //登录
        login({
            commit
        }, loginForm) {
            return new Promise((resolve, reject) => {
                tokenApi.login(loginForm).then(response => {
                    if (response != false) {
                        //解析token
                        var Base64 = require("js-base64").Base64;
                        var token = response.data.access_token;
                        var tokenArray = token.split('.');
                        var decode = Base64.decode(tokenArray[1]);
                        var json = JSON.parse(decode);
                        //获取过期时间
                        var exp = json.exp;
                        //转化为时间格式
                        var expDate = new Date(exp * 1000);
                        commit('SET_EXPRIED', expDate);
                        //所属医院编码
                        var organCode = response.data.user.organCode;
                        localStorage.setItem("organCode", organCode)
                        //用户类型
                        var userType = response.data.user.userType;
                        commit('SET_TYPE', userType);
                        localStorage.setItem("userType", userType)
                        //姓名
                        var userName = json.userName;
                        commit('SET_NAME', userName);
                        //用户id
                        var userId = json.userId;
                        commit('SET_ID', userId);

                        var permission = JSON.stringify(response.data.user.permission);
                        // var permission = json.permission;
                        commit('SET_PERMISSION', permission);
                        localStorage.setItem("permission", permission)

                        //refresh_token
                        var refresh_token = response.data.refresh_token;
                        tokenJwt.setRefreshToken(refresh_token);
                        commit('SET_REFRESH_TOKEN', refresh_token);
                        //设置token
                        tokenJwt.setToken(token);
                        commit('SET_TOKEN', token);
                        resolve(response);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        bindingLogin({
            commit
        }, response){
            return new Promise((resolve, reject) => {
                if (response != false) {
                    //解析token
                    var Base64 = require("js-base64").Base64;
                    var token = response.access_token;
                    var tokenArray = token.split('.');
                    var decode = Base64.decode(tokenArray[1]);
                    var json = JSON.parse(decode);
                    //获取过期时间
                    var exp = json.exp;
                    //转化为时间格式
                    var expDate = new Date(exp * 1000);
                    commit('SET_EXPRIED', expDate);
                    //所属医院编码
                    var organCode = response.user.organCode;
                    localStorage.setItem("organCode", organCode)
                    //用户类型
                    var userType = response.user.userType;
                    commit('SET_TYPE', userType);
                    localStorage.setItem("userType", userType)
                    //姓名
                    var userName = json.userName;
                    commit('SET_NAME', userName);
                    //用户id
                    var userId = json.userId;
                    commit('SET_ID', userId);
    
                    var permission = JSON.stringify(response.user.permission);
                    // var permission = json.permission;
                    commit('SET_PERMISSION', permission);
                    localStorage.setItem("permission", permission)
    
                    //refresh_token
                    var refresh_token = response.refresh_token;
                    tokenJwt.setRefreshToken(refresh_token);
                    commit('SET_REFRESH_TOKEN', refresh_token);
                    //设置token
                    tokenJwt.setToken(token);
                    commit('SET_TOKEN', token);
                    resolve(response);
                }else{
                    reject()
                }
            })
        },
        //刷新token
        refreshToken({ commit }) {
            return new Promise((resolve) => {
                var refreshToken = tokenJwt.getRefreshToken();
                api.post(`/user/refreshToken?refreshToken=${refreshToken}`).then(rsp => {
                    if (rsp != false) {
                        let token = rsp.data.access_token;
                        tokenJwt.setToken(token);
                        commit('SET_TOKEN', token);
                    }
                });
                resolve();
            });
        },

        //退出登录
        loginOut({ commit }) {
            return new Promise((resolve) => {
                tokenJwt.removeToken();
                tokenJwt.removeRefreshToken();
                commit('SET_EXPRIED', 0);
                commit('SET_NAME', '');
                commit('SET_ID', '');
                commit('SET_TYPE', '');
                commit('SET_REFRESH_TOKEN', '');
                commit('SET_TOKEN', '');
                commit('SET_PERMISSION', '');

                localStorage.removeItem("store");
                localStorage.removeItem("permission");
                resolve();
            })
        },

        //三方登录
        thirdlogin({
            commit
        }, loginForm) {
            return new Promise((resolve, reject) => {
                tokenApi.thirdlogin(loginForm).then(response => {
                    console.log(response,888888)
                    resolve(response);
                    //解析token
                    var Base64 = require("js-base64").Base64;
                    var token = response.data.access_token;
                    var tokenArray = token.split('.');
                    var decode = Base64.decode(tokenArray[1]);
                    var json = JSON.parse(decode);
                    //获取过期时间
                    var exp = json.exp;
                    //转化为时间格式
                    var expDate = new Date(exp * 1000);
                    commit('SET_EXPRIED', expDate);
                    //所属医院编码
                    var organCode = response.data.user.organCode;
                    localStorage.setItem("organCode", organCode)
                    //用户类型
                    var userType = response.data.user.userType;
                    commit('SET_TYPE', userType);
                    localStorage.setItem("userType", userType)
                    //姓名
                    var userName = json.userName;
                    commit('SET_NAME', userName);
                    //用户id
                    var userId = json.userId;
                    commit('SET_ID', userId);

                    var permission = JSON.stringify(response.data.user.permission);
                    commit('SET_PERMISSION', permission);
                    localStorage.setItem("permission", permission)

                    //refresh_token
                    var refresh_token = response.data.refresh_token;
                    tokenJwt.setRefreshToken(refresh_token);
                    commit('SET_REFRESH_TOKEN', refresh_token);

                    //设置token
                    tokenJwt.setToken(token);
                    commit('SET_TOKEN', token);
                }).catch(error => {
                    reject(error);
                })
            })
        },
    }
});

export default store


